module.exports = __webpack_public_path__ + "img/ic_food_top.9bbe8fd4.png";